<template>
    <!-- Contents -->
    <!-- Feature Level Label -->
    <div   class="col-span-6 w-full pl-2 text-gray-500 text-md font-medium">Feature Level</div>
<!--    <div  class="grid grid-cols-6 px-3 py-2 text-sm font-medium rounded-md">-->
    <div  class="group grid grid-cols-6 gap-x-2 plain-link items-center px-3 text-sm leading-5 font-medium rounded-md focus:outline-none flex flex-row">

            <!-- Status Icon -->
            <div    class="col-span-1 py-2 flex flex-row">
                <!-- Loading Icon -->
                <span   v-if="$data._saving"
                        class="mr-2 lnr icon-loading text-grey-500 animate-spin"></span>

                <!-- Successfully Saved Icon -->
                <span   v-else-if="$data._hasError"
                        :class="iconError"></span>

                <!-- Company Icon -->
                <span   v-else
                        class="lnr icon-podium"></span>
            </div>

            <!-- Feature Level Selection -->
            <div    class="col-span-5">
                <feature-level-selection    v-model:saving="$data._saving"
                                            :has-error="$data._hasError"
                                            @updateHasError="$data._hasError = $event"
                ></feature-level-selection>
            </div>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from "@/mixins/IconNamesMixin";
import FeatureLevelSelection from "./FeatureLevelSelection.vue";

export default {
    name: "FeatureLevelSidebar",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {FeatureLevelSelection},
    emits: [],
    props: {
        // Props
    },
    data() {
        return {
            // Data Properties
            _saving: false,
            _hasError: false,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        // Methods
    },
    computed: {},
    watch: {
    },
}
</script>

<style scoped>

</style>